import PropTypes from 'prop-types';

import { Stack } from '@mui/material';

import { paths } from 'src/routes/paths';

import { useTranslate } from 'src/locales';
import { useAuthContext } from 'src/auth/hooks';
import { useEntityContext } from 'src/entity/hooks';
import { useGetAdvancedUserPermissions } from 'src/api/users-entities';

import Iconify from 'src/components/iconify';
import NavItemMini from 'src/components/nav-section/mini/nav-item';
import NavItemHorizontal from 'src/components/nav-section/horizontal/nav-item';

// ----------------------------------------------------------------------

const RenderNavItem = ({ isCompact, ...props }) =>
  isCompact ? <NavItemMini {...props} /> : <NavItemHorizontal {...props} />;

RenderNavItem.propTypes = {
  isCompact: PropTypes.bool,
};

// ----------------------------------------------------------------------

const NavGlobal = ({ sx, isCompact = false, showLogoff = true }) => {
  const { t } = useTranslate();

  const { user, logout } = useAuthContext();
  const { entity } = useEntityContext();
  const { isSuperadmin } = user;

  const { permissions, parentPermissions } = useGetAdvancedUserPermissions(user?.id, entity?.id);

  return (
    <Stack sx={{ p: 2, ...sx }} spacing={0.25}>
      {(isSuperadmin || permissions?.is_admin || parentPermissions?.is_admin) && (
        <RenderNavItem
          isCompact={isCompact}
          title={isCompact ? null : t('common.admin')}
          icon={<Iconify icon="mdi:shield-account" />}
          path={paths.entity.modules.administration.root(entity?.parent || entity?.id)}
        />
      )}

      {isSuperadmin && (
        <RenderNavItem
          isCompact={isCompact}
          title={isCompact ? null : t('common.superadmin')}
          icon={<Iconify icon="mdi:shield-crown" />}
          path={paths.superadmin.root}
        />
      )}
      {showLogoff && (
        <RenderNavItem
          isCompact={isCompact}
          title={isCompact ? null : t('common.logoff')}
          icon={<Iconify icon="material-symbols:logout-rounded" />}
          onLinkClick={logout}
        />
      )}
    </Stack>
  );
};

NavGlobal.propTypes = {
  sx: PropTypes.object,
  isCompact: PropTypes.bool,
  showLogoff: PropTypes.bool,
};

export default NavGlobal;
